import React, { useRef, useEffect } from "react";
import { Card } from "react-bootstrap";
import { injectLinks } from "./injectLinks";
import { isEn } from "app/i18n/i18n";
import { Row, Col, Container } from "react-bootstrap";
import { useScrollToAnchor } from "../../lib/hooks/useScrollToAnchor";
import { CategoryLinks } from "./CategoryLinks";
import "./faq.css";

export const FaqBody = (props) => {
  useScrollToAnchor();

  return (
    <Container fluid>
      <Row className="mx-md-3">
        <Col md="3">
          <CategoryLinks {...props} />
        </Col>

        <Col md="9">
          <FaqTextArea {...props} />
        </Col>
      </Row>
    </Container>
  );
};

export const FaqTextArea = ({ categories, faq, setCardRefs, cardRefs }) => (
  <section>
    {categories.map((category, index) => (
      <FaqCard key={index} category={category} faq={faq} setCardRefs={setCardRefs} cardRefs={cardRefs} />
    ))}
  </section>
);

const FaqCard = ({ category, faq, setCardRefs, cardRefs }) => {
  const faqItems = faq.filter((item) => item.category_en === category || item.category_ja === category);
  const categoryId = category.replace(/ /g, "_");
  const ref = useRef(null);

  useEffect(() => {
    setCardRefs((prev) => ({ ...prev, [categoryId]: ref }));
  }, []);

  return (
    <Card className="page border-grey shadow-lg mb-3" id={categoryId} ref={ref}>
      <Card.Header id={categoryId} className="border-0">
        <h2 className="font-weight-lighter mb-0">{category}</h2>
      </Card.Header>

      <Card.Body>
        {faqItems.map((faqItem, index) => (
          <FaqQuestion key={index} {...faqItem} />
        ))}
      </Card.Body>
    </Card>
  );
};

export const FaqQuestion = ({ question_en, question_ja, answer_en, answer_ja }) => (
  <div>
    <h5 className="font-weight-bold">{isEn() ? question_en : question_ja}</h5>
    <p className="whitespace-pre-line">{injectLinks(isEn() ? answer_en : answer_ja)}</p>
    <br />
  </div>
);
